import { URLS } from "@app/shared";

export const contactUsBreadcrumb = [
  { label: "home", link: URLS.home },
  { label: "contactUsPage.title" },
];
